import request from "@/http/http"
import type { IndustryCategory, AreaItemVO, ModuleItemVO } from "@/api"

export interface BrandItemVO {
  brandId: string
  brandName: string
}

/**
 *
 * 搜索品牌列表
 * @param query
 */
export async function queryBrandList(brandName: string): Promise<BrandItemVO[]> {
  try {
    const result = await request.get(`/business/brand/searchByName/${brandName}`)
    return result?.data
  } catch (error) {
    throw error
  }
}

export interface CityItemVO {
  id: string
  areaCode: string
  areaName: string
  parentCode: string
  level: string
}

/**
 *
 * 搜索城市列表
 * @param query
 */
export async function queryCityList(areaName: string): Promise<CityItemVO[]> {
  try {
    const result = await request.get(`/business/area/searchByName/${areaName}`)
    return result?.data
  } catch (error) {
    throw error
  }
}

export interface BankAuthorityVO {
  // 品牌ID
  brandId: string
  // 品牌名字
  brandName: string
  // 品牌权限是否有效，若为false卡片上加锁
  active: boolean
  // 品牌类型
  industryCategory: IndustryCategory
  // 沙盘类型（沙盘类型）
  brandSandTableType: string
}

interface BankAuthorityArgs {
  // 品牌名称
  brandName: string
  // 沙盘类型
  sandTableType: string
}

/**
 * 获取已开通品牌
 */
export async function getListBankAuthority(args: BankAuthorityArgs): Promise<BankAuthorityVO[]> {
  try {
    const result = await request.get<BankAuthorityVO[]>("/system/brand/auth", {
      params: args,
    })
    return result?.data
  } catch (error) {
    throw error
  }
}

type AreaModuleTypesResult = {
  brandId: string
  area: AreaItemVO[]
  modules: ModuleItemVO[]
}

/**
 * 获取品牌区域范围和模块权限
 */
export async function getAreaModuleTypes(sandTableId: string): Promise<AreaModuleTypesResult> {
  try {
    const result = await request.get<AreaModuleTypesResult>(
      `/business/sandTable/auth/detail/${sandTableId}`,
    )
    return result?.data
  } catch (error) {
    throw error
  }
}

interface AuthorityBatchArgs {
  // 品牌id
  brandId: string
  // 区域编码，限制是二级区域编码
  areaCode: string
}

/**
 * 虚拟账户-创建
 */
export async function setAuthority(args: AuthorityBatchArgs): Promise<any> {
  try {
    const result = await request.post(`/virtual/account/create`, args)
    return result?.data
  } catch (error) {
    throw error
  }
}
